import { useState, useEffect } from 'react';

// Captures the original stop-loss / target / exit-type / target-status of an
// existing recommendation (for edit-path change detection). Verbatim from the form.
const useInitialTradeValues = (tradeRecommendation) => {
  // Start as null = "not captured yet" (so change detection can skip until set).
  const [initialStopLoss, setInitialStopLoss] = useState(null);
  const [initialTargetOne, setInitialTargetOne] = useState(null);
  const [initialExitType, setInitialExitType] = useState(null);
  const [initialTargetOneStatus, setInitialTargetOneStatus] = useState(null);

  // On edit, remember each original value so submit can detect what changed.
  useEffect(() => {
    if (tradeRecommendation) {
      setInitialStopLoss(Number(tradeRecommendation.stopLoss));
    }
  }, [tradeRecommendation]);
  useEffect(() => {
    if (tradeRecommendation) {
      setInitialTargetOne(Number(tradeRecommendation.targetOne));
    }
  }, [tradeRecommendation]);
  useEffect(() => {
    if (tradeRecommendation) {
      setInitialExitType(Number(tradeRecommendation.exitTypeId));
    }
  }, [tradeRecommendation]);

  useEffect(() => {
    if (tradeRecommendation) {
      console.log(`status = ${tradeRecommendation.targetOneStatus}`)
      setInitialTargetOneStatus(tradeRecommendation.targetOneStatus);
    }
  }, [tradeRecommendation]);

  return {
    initialStopLoss,
    initialTargetOne,
    initialExitType,
    initialTargetOneStatus,
  };
};

export default useInitialTradeValues;
